export interface Product {
  id: string; // Stripe product id (prod_...) or "strapi-<id>" for external items
  priceId: string; // Stripe price id; empty for external items
  name: string;
  price: number; // in major units (pounds)
  category: string;
  artist: string;
  sizes: string[];
  canPersonalMessage: boolean;
  colorOptions: string[];
  outOfStock: boolean;
  isNew: boolean;
  imageUrls: string[];
  description: string;
  isActive: boolean;
  onSale: boolean;
  isDigital: boolean;
  /** "stripe" = bought on-site via cart/checkout; "external" = links out (e.g. Bandcamp). */
  source: "stripe" | "external";
  /** For external products: where the Buy button sends the customer. */
  externalUrl?: string;
  /** For external products: the platform label (e.g. "Bandcamp"). */
  platform?: string;
}

export interface CartItem {
  productId: string;
  name: string;
  quantity: number;
  price: number;
  size: string | null;
  colour: string | null;
  personalMessage: string | null;
  product: Product;
}

export interface NewsItem {
  id: number;
  link: string;
  imgSrc: string;
  date: string;
  title: string;
  description: string;
}
export interface BlogPost {
  id: number;
  title: string;
  description: string;
  thumbnailImgSrc: string | null;
  thumbnailAltText: string;
  thumbnailVidSrc: string | null;
  contentPath: string;
  publishDate: Date;
  author: string;
  visible: boolean;
  category: BlogCategory[];
}

export enum BlogCategory {
  RELEASES = "Releases",
  GIGS = "Gigs",
  REVIEWS = "Reviews",
  INTERVIEWS = "Interviews",
  ARTISTSPOTLIGHT = "Artist Spotlight",
  NEWS = "News",
}

export interface CatalogueItem {
  id: number;
  name: string;
  imgSrc: string;
  artist: string;
  date: string;
  contribution: string;
  description: string;
}

export interface Artist {
  id: number;
  name: string;
  associates: Associate[];
}

export interface Associate {
  id: number;
  name: string;
  thumbnailImgSrc: string;
  URL: string;
  artists: Artist[];
  description: string;
}

export interface HomePageCarouselItem {
  id: number;
  title: string;
  caption: string;
  imageSrcURL: string;
  altText: string;
  linkURL: string;
  active: boolean;
}
